import React from "react";
import calendarIcon from "../../assets/images/calendar.png";
import timeIcon from "../../assets/images/time.png";
import moneyIcon from "../../assets/images/money.png";

const AppointmentDetailsCard = ({ date, time, price = "\u20B91000" }) => {
  return (
    <div style={styles.infoCard}>
      <div style={styles.cardTitle}>Appointment Details</div>

      <div style={styles.rowIcon}>
        <img src={calendarIcon} alt="Calendar" style={styles.iconImage} />
        <span style={styles.rowText}>{date}</span>
      </div>

      <div style={styles.rowIcon}>
        <img src={timeIcon} alt="Time" style={styles.iconImage} />
        <span style={styles.rowText}>{time}</span>
      </div>

      <div style={styles.rowIcon}>
        <img src={moneyIcon} alt="Price" style={styles.iconImage} />
        <span style={styles.rowText}>{price}</span>
      </div>
    </div>
  );
};

const styles = {
  infoCard: {
    backgroundColor: "#fff",
    margin: "14px 10px",
    borderRadius: 20,
    padding: 16,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  cardTitle: {
    color: "#2E2E2E",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "12px",
  },
  rowIcon: {
    display: "flex",
    alignItems: "center",
    marginBottom: 6,
  },
  iconImage: {
    width: 16,
    height: 16,
    objectFit: "contain",
    marginRight: 8,
  },
  rowText: {
    fontSize: 16,
    color: "#1D1617",
    fontWeight: 500,
  },
};

export default AppointmentDetailsCard;
